<!-- 弛万定制打印采购售后单 -->
<template>
    <div v-loading="loading" style="position: relative">
        <div id="printContent" class="print-zone">
            <div class="print-title-view">
                <div v-if="isEditTitle" class="print-title">
                    <el-input type="text" style="width: 70%" v-model="titleConfig.RValue"></el-input>
                </div>
                <div v-else class="print-title">{{ orderData.IsHaveTitleSet ? orderData.OrderTitle : titleConfig.RValue }}</div>
            </div>
            <div class="print-content">
                <div>退货单号：{{ orderData.ReturnCode }}</div>
                <div>退货日期：{{ orderData.ReturnTime }}</div>
            </div>
            <div class="print-table-main">
                <div class="div-table-row">
                    <div class="div-table-cell" style="width: 20%;">供应商名称</div>
                    <div class="div-table-cell" style="width: 80%">{{ orderData.EntpCusName }}</div>
                </div>
                <div class="div-table-row">
                    <div class="div-table-cell" style="width: 20%">联系电话</div>
                    <div class="div-table-cell" style="width: 80%">{{ orderData.PhoneNum }}</div>
                </div>
                <div class="div-table-row">
                    <div class="div-table-cell" style="width: 6%">序号</div>
                    <div class="div-table-cell" style="width: 20%;">汽配编码</div>
                    <div class="div-table-cell" style="width: 15%;">配件名称</div>
                    <div class="div-table-cell" style="width: 15%;">车型</div>
                    <div class="div-table-cell" style="width: 7%">数量</div>
                    <div class="div-table-cell" style="width: 7%">单位</div>
                    <div class="div-table-cell" style="width: 10%">退单价</div>
                    <div class="div-table-cell" style="width: 10%">退款总额</div>
                    <div class="div-table-cell" style="width: 10%">仓位</div>
                </div>
                <div class="div-table-row" v-for="(AP, index) in orderData.DetailList" :key="index">
                    <div class="div-table-cell" style="width: 6%">{{ index + 1 }}</div>
                    <div class="div-table-cell" style="width: 20%;">{{ AP.APCode }}</div>
                    <div class="div-table-cell text-hidden" style="width: 15%;">{{ AP.GoodName }}</div>
                    <div class="div-table-cell text-hidden" style="width: 15%;">{{ AP.AutoSerise }}</div>
                    <div class="div-table-cell" style="width: 7%">{{ AP.ReturnCount }}</div>
                    <div class="div-table-cell" style="width: 7%">{{ AP.Unit }}</div>
                    <div class="div-table-cell" style="width: 10%">{{ AP.ReturnPrice }}</div>
                    <div class="div-table-cell" style="width: 10%">{{ (AP.ReturnPrice * AP.ReturnCount).toFixed(2) }}</div>
                        <div class="div-table-cell" style="width: 10%">{{ AP.GoodsLocation }}</div>
                </div>
                <div class="div-table-row">
                    <div class="div-table-cell" style="width: 6%"></div>
                    <div class="div-table-cell" style="width: 20%;"></div>
                    <div class="div-table-cell" style="width: 15%;"></div>
                    <div class="div-table-cell" style="width: 15%;">总数量</div>
                    <div class="div-table-cell" style="width: 7%">{{ orderData.TotalCount }}</div>
                    <div class="div-table-cell" style="width: 7%">总价</div>
                    <div class="div-table-cell" style="width: 10%"></div>
                    <div class="div-table-cell" style="width: 10%">{{ orderData.ReturnMoney }}</div>
                    <div class="div-table-cell" style="width: 10%"></div>
                </div>
            </div>
            <div class="row">退款方式：{{ orderData.PayTypeName }}</div>
            <div class="row">退货原因：{{ orderData.Reasons }}</div>
            <!--    脚注    -->
            <div
                class="order-remark"
                slot="content"
                v-if="!isEditConfig"
                v-html="config.RValue.replace(/\n/g, '<br/>')"
            ></div>
            <div class="order-setcontent" v-if="isEditConfig">
                <el-input type="textarea" resize="auto" rows="3" v-model="config.RValue"></el-input>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="btn-ctn-left">             
                <div class="re-set">
                    <el-button class="btn-primary" @click="isEditTitle = true" v-if="!isEditTitle"
                        >编辑标题</el-button
                    >
                    <el-button class="btn-primary" @click="submitTitleConfig()" v-if="isEditTitle">保存标题</el-button>
                </div>
                <!--   脚注   -->
                <!-- <div class="re-set">
                    <el-button class="btn-primary" @click="setConfig()" v-if="!isEditConfig"
                        >编辑脚注</el-button
                    >
                    <el-button class="btn-primary" @click="submitConfig()" v-if="isEditConfig">保存脚注</el-button>
                </div> -->
            </div>
            <div v-if="!isEditConfig" class="re-submit">
                <el-button class="btn-primary" @click="lodopPrint" v-if="!isDefaultSet">打印</el-button>
                <el-button class="btn-primary" @click="printedRecord" v-print="'#printPReturnContent'" v-else>打印</el-button>
                <el-button @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
import QRCode from 'qrcode';
import JsBarcode from 'jsbarcode';
export default {
    name: '',
    components: {},
    props: {
        isInit: {
            default: true,
            type: Boolean
        },
        printIds: {
            type: Array
        }
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            loading: true,
            orderData: {},
            allPrice: 0,
            allNum: 0,
            permission: {},
            userMsg:userMsg,
            company: userMsg.EntpName,
            isEditTitle: false, //编辑标题
            titleConfig: {
                RValue: userMsg.EntpName + '采购入库退货单'
            }, //标题配置
            config: {
                RValue:'',
            }, // 脚注配置
            isEditConfig: false, // 编辑脚注
            capitalAmount: '',
            imgUrl: '',
            isPrint: false,
            isPreview: false,
            isDefaultSet: false,
            sortField: 'sortnum', //排序
        };
    },
    watch: {
        orderData(value) {
            if (this.imgUrl || !this.isInit) return;
            this.$nextTick(function () {
                JsBarcode('#barcode', value.ReturnCode, {
                    width: 1,
                    height: 40,
                    fontSize: 14,
                    margin: 0,
                    displayValue: true
                });
            });
        }
    },
    created() {},
    mounted() {
        if (this.isInit) {
            this.init();
        } else this.loading = false;
    },
    methods: {
        init() {
            this.orderData = {};
            let sortField = this.$util.getLocalStorage('purRetunr_print_' + this.userMsg.EmployeeId);
            if (sortField) this.sortField = sortField;            
            this.getConfigByCodes().then(() => {
                this.getSaleOrder();
            });
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['dycgth', 'dycgshbt', 'dyyl', 'syllqdysz'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'dycgth':
                                    this.config = data[i];
                                    break;
                                case 'dycgshbt':
                                    this.titleConfig = data[i];
                                    if (!this.titleConfig || !this.titleConfig.RValue) this.titleConfig.RValue = this.company + '采购入库退货单';
                                    break;
                                case 'dyyl':
                                    this.isPreview = result;
                                    break;
                                case 'syllqdysz':
                                    this.isDefaultSet = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                let strBodyStyle = `<style>
                    .order-detail {
                        color: #000;
                    }
                    .order-remark {
                        width: 762px;
                        display: -webkit-flex;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        margin-left: 10px;
                        margin-right: 10px;
                        padding: 0px 0px 15px 0px;
                        color: #000;
                    }
                    .print-title {
                        text-align: center;
                        font-size: 20px;
                        font-weight: bold;
                        color: #000;
                    }
                    .print-content {
                        width: 762px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        color: #000;
                        margin: 12px 0;
                    }
                    .dialog-footer {
                        text-align: right;
                    }
                    .print-table-main {
                        width: 762px;
                        margin-bottom: 16px;
                        font-size:12px;
                    
                    }
                    .div-table-cell {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        height: auto;
                        line-height: 30px;
                        padding-left: 10px;
                        border-top: 1px solid #000;
                        border-right: 1px solid #000;
                        border-bottom: 1px solid #000;
                        color: #000;
                    }
                    .text-hidden{
                        overflow: hidden;
                        text-overflow:clip !important;
                        white-space: nowrap;
                    }
                    .row {
                        color: #000;
                        margin-bottom: 16px;
                    }
                    .div-table-row {
                        display: flex;
                        border-left: 1px solid #000;
                        margin: 0;
                        font-size: 14px;
                    }
                    </style>`;

                let strPrintHtml = strBodyStyle + '<body>' + document.getElementById('printContent').innerHTML + '</body>';
                let printHight = document.getElementById('printContent').clientHeight;
                if (printHight <= 1080) {
                    LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', ''); // 这里3表示纵向打印且纸高“按内容的高度”；580表示纸宽58mm；45表示页底空白4.5mm
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '100%', strPrintHtml);
                } else {
                    LODOP.SET_PRINT_PAGESIZE(0, '210mm', '286mm', '');
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '100%', strPrintHtml);
                    LODOP.NEWPAGEA();
                }

                LODOP.SET_PRINTER_INDEX(-1);
                if (this.isPreview) LODOP.PREVIEW();
                //预览
                else LODOP.PRINT(); // 直接打印

                setTimeout(() => {
                    this.printedRecord();
                }, 1000);
            }
        },
        printedRecord() {
            this.loading = true;
            this.$util
                .printedRecord({ OrderId: this.orderData.EntpCusPOId, Type: 10 }, false)
                .then(() => {
                    this.loading = false;
                    this.isPrint = true;
                    if (!this.isInit) this.$emit('closeDialog', true);
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 取消
        cancel() {
            this.$emit('closeDialog', this.isPrint);
        },
        // 获取表格数据
        getSaleOrder() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpPurReturnOrder/GetHKOrderDetailForPrint',
                    data: {
                        PReturnId: this.printIds[0].PReturnId,
                        SortField: this.sortField
                    },
                    hideLoading: this.isInit
                })
                .then(res => {
                    if(res.errcode!=0){
                        this.$message.error(res.errmsg);
                         this.loading = false;
                        return;
                    }
                    let data = res.data;
                    this.orderData = res.data;
                    if(this.orderData.IsHaveTitleSet){
                        this.config.RValue = this.orderData.FootNote;
                    }
                    if (this.orderData.ReturnMoney > 0) this.capitalAmount = this.$util.moneyToCapital(-this.orderData.ReturnMoney);
                    let that = this;
                    if (that.isInit) that.loading = false;
                    else {
                        this.$nextTick(() => {
                            setTimeout(() => {
                                that.lodopPrint();
                            }, 100);
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        setConfig() {
            this.isEditConfig = true;
        },
        // 提交脚注
        submitConfig() {
            if (!this.config.RValue || !this.config.RValue.trim()) {
                this.$message.error('请输入脚注');
                return;
            }
            this.isEditConfig = false;
        },
        //提交打印标题
        submitTitleConfig() {
            this.isEditTitle = false;
            this.$util.setSysConfigValue(this.titleConfig.ConfigId, this.titleConfig.RValue);
        },
        setSortField(field) {
            this.$util.setLocalStorage('purRetunr_print_' + this.userMsg.EmployeeId, field);
            this.sortField = field;
            this.getSaleOrder();
        }        
    }
};
</script>

<style lang="less" scoped media="print">
.print-title-view {
    width: 100%;
    position: relative;
    justify-content: space-between;
    align-items: flex-end;
    padding: 0;
    .order-code {
        display: inline-block;
        margin-bottom: -30px;
    }
    .qrcode-canvas,
    .qrcode-image {
        width: 80px;
        height: 80px;
        display: inline-block;
        vertical-align: top;
    }
}
.order-detail {
    color: #000;
    padding-right: 5px;
}

.order-setcontent {
    padding: 0px 0px 15px 0px;
    color: #000;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
}
.re-submit {
    text-align: right;
}

.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding: 0px 0px 15px 0px;
    color: #000;
}
.print-title {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
}
.print-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #000;
    margin: 12px 0;
}
.dialog-footer {
    text-align: right;
}
.print-table-main {
    margin-bottom: 16px;
    font-size: 12px;
    .div-table-row {
        border-color: black;
        margin-left: 0;
    }
    .div-table-cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: auto;
        line-height: 30px;
        padding-left: 10px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
        color: #000;
    }
    .text-hidden{
        overflow: hidden;
        text-overflow:clip !important;
        white-space: nowrap;
    }
}
.row {
    color: #000;
    margin-bottom: 16px;
}
.btn-ctn-left {
    display: flex;
}
.fdzt {
    font-size: 14px;
}
.fwb {
    font-weight: bold;
}
.btd {
    border-bottom: 1px dashed #000;
    font-weight: bold;
}

.print-orderDetail {
    margin-bottom: 10px;
    font-size: 14px;
    color: #000;
}
.print-orderDetail .row {
    margin-left: -10px;
    margin-right: -10px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin-bottom: 4px;
}
.print-orderDetail .row::after,
.print-orderDetail .row::before {
    display: table;
    content: '';
    clear: both;
}

.print-orderDetail .row .col {
    float: left;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding-left: 10px;
    padding-right: 10px;
    line-height: 18px;
    height: 18px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.print-orderDetail .col-5 {
    width: 20.83333%;
}
.print-orderDetail .col-6 {
    width: 25%;
}
.print-orderDetail .col-7 {
    width: 29.16667%;
}
.print-orderDetail .col-8 {
    width: 33.33333%;
}
.print-orderDetail .row .height40 {
    height: 40px !important;
}
.print-orderDetail .row .barfa {
    height: auto;
    position: absolute;
    right: 65px;
}

.print-orderDetail .row .col .label_l {
    width: 70px;
    text-align: left;
    vertical-align: middle;
    float: left;
    line-height: 18px;
}
.print-orderDetail .row .col .label_r {
    width: 70px;
    text-align: right;
    vertical-align: middle;
    float: left;
    line-height: 18px;
}
.w60 {
    width: 60px !important;
}
.print-orderDetail .row .col .grid-content {
    display: inline-block;
    min-height: 18px;
    line-height: 18px;
    border-radius: unset;
}
.print-orderDetail .row .col .debts {
    padding-top: 3px;
}
.print-orderDetail .row .col .grid-content::after,
.print-orderDetail .row .col .grid-content::before {
    display: table;
    content: '';
    clear: both;
}
.print-orderDetail .rkCol {
    height: auto !important;
    width: 65%;
    padding-right: 0px !important;
    overflow: unset !important;
    white-space: unset !important;
    text-overflow: unset !important;
}
.print-orderDetail .rkCol .grid-content {
    overflow: hidden !important;
    word-break: break-all !important;
    word-wrap: break-word !important;
    white-space: break-spaces !important;
    width: 85% !important;
}
table,
td,
th {
    border-width: 1px;
    border-style: solid;
    border-collapse: collapse;
    color: #000;
    padding-bottom: 3px;
    padding-top: 3px;
    padding-left: 2px;
}
tfoot {
    display: none;
}
</style>
